import {FieldsController} from "../../lib/fields_controller";

export enum ActionType {
    MarkElement,
    UnmarkElement,
    ExtendBlock,
    UnextendBlock,
    ExtendElement,

    // Установить в поле конфига значения из "метаданных" страницы. К таким метаданным, например, относится
    // текущий урл страницы
    SetMetaValueToField
}

/*
Действия:
1. Промаркировать (элемент + типа маркировки)
2. Расширить (элемент + вариант расширения)
 */
export interface MenuAction {
    action: ActionType,
    mark_params?: MarkActionParams,
    set_meta_value_params?: SetMetaValueParams,
}

export interface MarkActionParams {
    fieldName: string;
}

export interface SetMetaValueParams {
    fieldName: string;
    xpath: string;
}

export function markAction(field: string): MenuAction {
    return {
        action: ActionType.MarkElement,
        mark_params: {
            fieldName: field,
        }
    }
}

export function unmarkAction(field: string): MenuAction {
    return {
        action: ActionType.UnmarkElement,
        mark_params: {
            fieldName: field,
        }
    }
}

export function extendBlockAction(): MenuAction {
    return {
        action: ActionType.ExtendBlock,
    }
}

export function unextendBlock(): MenuAction {
    return {
        action: ActionType.UnextendBlock,
    }
}

export function extendElement(): MenuAction {
    return {
        action: ActionType.ExtendElement,
    }
}

export function setMetaField(fieldName: string, xpath: string): MenuAction {
    return {
        action: ActionType.SetMetaValueToField,
        set_meta_value_params: {
            fieldName: fieldName,
            xpath: xpath,
        }
    }
}
